var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Button } from 'antd';
export var CircleButton = function (props) {
    var hasText = String(props.className || '').indexOf('has-text') > -1;
    return (React.createElement(Button, __assign({ type: hasText ? 'link' : undefined, shape: hasText ? undefined : 'circle' }, props)));
};
export default CircleButton;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd-components/esm/circle-button/index.js
// module id = 622
// module chunks = 0